import type { FederatedSearchAnalyticsOutcome } from '~/utils/algoliaHelpers'
import {
  consumeFederatedSearchAnalyticsOutcome,
  setFederatedSearchAnalyticsOutcome,
} from '~/utils/federatedSearchAnalyticsSession'

export const useFederatedSearchAnalyticsSession = () => ({
  setFederatedSearchAnalyticsOutcome: (
    outcome: FederatedSearchAnalyticsOutcome
  ) => setFederatedSearchAnalyticsOutcome(outcome),

  consumeFederatedSearchAnalyticsOutcome: () =>
    consumeFederatedSearchAnalyticsOutcome(),
})
